import React from 'react';

export const BrandMark = ({ compact = false, tagline }: { compact?: boolean; tagline?: string }) => (
  <span className={`brand ${compact ? 'brand-compact' : ''}`} aria-label="StoryboardSmith">
    <span className="brand-icon" aria-hidden="true">
      <span className="brand-sheet brand-sheet-one" />
      <span className="brand-sheet brand-sheet-two" />
      <span className="brand-sheet brand-sheet-three" />
    </span>
    {!compact && <span className="brand-copy"><span className="brand-name">Storyboard<span>Smith</span></span>{tagline && <small>{tagline}</small>}</span>}
  </span>
);
